import Vue from 'vue'
import VueRouter from 'vue-router'
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error=> error)
}
Vue.use(VueRouter)

const routes = [
    {
        path: '/openlogin',
        name: 'OpenLogin',
        component: () => import('../views/OpenLogin.vue')
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('../views/Login.vue')
    },
    {
        path: '/group',
        name: 'Main',
        meta: {
            requireAuth:true
        },
        component: () => import('../layout/group/Main.vue'),
        children: [
            {
                path: 'SelectScope',
                name: 'SelectScope',
                component: () => import('../views/group/SelectScope.vue')
            },
            {
                path: 'Home',
                name: 'Home',
                component: () => import('../views/group/Home.vue')
            },
            {
                path: 'StatReading',
                name: 'StatReading',
                component: () => import('../views/group/StatReading.vue')
            },
            {
                path: 'StatReadingDetail',
                name: 'StatReadingDetail',
                component: () => import('../views/group/StatReadingDetail.vue')
            },
            {
                path: 'Ranking',
                name: 'Ranking',
                component: () => import('../views/group/Ranking.vue')
            },
            {
                path: 'StatLookWords',
                name: 'StatLookWords',
                component: () => import('../views/group/StatLookWords.vue')
            },
            {
                path: 'StatFollowReading',
                name: 'StatFollowReading',
                component: () => import('../views/group/StatFollowReading.vue')
            },
            {
                path: 'StatMb',
                name: 'StatMb',
                component: () => import('../views/group/StatMb.vue')
            },
            {
                path: 'BoXueJia',
                name: 'BoXueJia',
                component: () => import('../views/group/BoXueJia.vue')
            },
            {
                path: 'StatOnline',
                name: 'StatOnline',
                component: () => import('../views/group/StatOnline.vue')
            },]
    },

    {
        path: '/single',
        name: 'Main',
        meta: {
            requireAuth:true
        },
        component: () => import('../layout/single/Main.vue'),
        children: [
            {
                path: 'Home',
                name: 'Home',
                component: () => import('../views/single/Home.vue')
            },
            {
                path: 'ReadingTree',
                name: 'ReadingTree',
                component: () => import('../views/single/ReadingTree.vue')
            },
            {
                path: 'ReadingYearReport',
                name: 'ReadingYearReport',
                component: () => import('../views/single/ReadingYearReport.vue')
            },
            {
                path: 'ChineseLevel',
                name: 'ChineseLevel',
                component: () => import('../views/single/ChineseLevel.vue')
            },
            {
                path: 'LookWords',
                name: 'LookWords',
                component: () => import('../views/single/LookWords.vue')
            },
            {
                path: 'FollowReading',
                name: 'FollowReading',
                component: () => import('../views/single/FollowReading.vue')
            },
            {
                path: 'StudentJob',
                name: 'StudentJob',
                component: () => import('../views/single/StudentJob.vue')
            },
            {
                path: 'TeacherJob',
                name: 'TeacherJob',
                component: () => import('../views/single/TeacherJob.vue')
            },
            {
                path: 'Mb',
                name: 'Mb',
                component: () => import('../views/single/Mb.vue')
            },
            {
                path: 'BoXueJia',
                name: 'BoXueJia',
                component: () => import('../views/single/BoXueJia.vue')
            },
            {
                path: 'FlashCard1',
                name: 'FlashCard1',
                component: () => import('../views/single/FlashCard1.vue')
            },
            {
                path: 'StatOnline',
                name: 'StatOnline',
                component: () => import('../views/single/StatOnline.vue')
            },
            ]
    }

]

const router = new VueRouter({
    mode: 'history',
    routes
})


export default router
